import {logger} from 'yougile-util'

export interface Event<T> {
  type: string
  data?: T
}

export class EventBus {
  private static listeners: {[event: string]: Array<(data: any) => any>} = {}
  private static oneShotListeners: {
    [event: string]: Array<(data: any) => any>
  } = {}

  public static once(
    createEvent: (...args: any[]) => Event<any>,
    cb: (data: unknown) => void
  ): void {
    const {type} = createEvent()
    EventBus.oneShotListeners[type] = EventBus.oneShotListeners[type] || []

    EventBus.oneShotListeners[type].push(cb)
  }

  public static on<T>(
    createEvent: (...args: any[]) => Event<T>,
    cb: (data: T) => void
  ): void {
    const {type} = createEvent()
    EventBus.listeners[type] = EventBus.listeners[type] || []

    EventBus.listeners[type].push(cb)
  }

  public static off<T>(
    createEvent: (...args: any[]) => Event<T>,
    cb: (data: T) => void
  ): void {
    const {type} = createEvent()
    EventBus.listeners[type] = EventBus.listeners[type] || []

    const ix = EventBus.listeners[type].indexOf(cb)
    if (ix === -1) {
      logger.error(
        'EventBus handler not found, this possibly leads to a memory leak',
        type,
        new Error().stack
      )
      return
    }
    EventBus.listeners[type].splice(ix, 1)
  }

  public static dispatch<K, T extends Event<K>>({type, data}: T): any[] {
    const results = [...(EventBus.listeners[type] || [])].map(cb => cb(data))
    const oneShotResults = [...(EventBus.oneShotListeners[type] || [])].map(
      cb => cb(data)
    )
    EventBus.oneShotListeners[type] = []
    return [...results, ...oneShotResults]
  }
}
